import { restHost } from "../../../../../config";

const SOLR_SEARCH_REST_CONFIG_PROJECTS = (langPrefix) => ({
  host: `${restHost}${langPrefix}/api/search/projects`,
  pagerSize: 30,
  pageMode: "endless", // endless or pager or none
  fields: [],
  facets: [
    {
      id: "discipline",
      label: "Discipline",
      className: "uppercase",
      multiple: true,
    },
    {
      id: "category",
      label: "Category",
      className: "capitalize",
      multiple: true,
    },
    {
      id: "search",
      label: "Search",
      type: "search",
    },
    {
      id: "region",
      label: "Region",
      multiple: true,
      className: "capitalize",
      dependencies: [{ key: "discipline", value: ["Architecture"] }],
    },
    {
      id: "design",
      label: "Design",
      multiple: true,
      className: "capitalize",
      dependencies: [{ key: "discipline", value: ["Design"] }],
    },
    {
      id: "interior",
      label: "Interior",
      multiple: true,
      className: "capitalize",
      dependencies: [{ key: "discipline", value: ["Interior"] }],
    },
  ],
  presetFilters: [
    /* {
      field: "field_date",
      value: Math.floor(Date.now() / 1000),
      operator: "gte",
    }, */
  ],
  limit: 30, // set the default limit from /admin/config/search/search-api/endpoints/MY_CUSTOM_ENDPOINT/edit
  limits: [], // set in /admin/config/search/search-api/endpoints/MY_CUSTOM_ENDPOINT/edit
  page: 0, // use sort by relevance as default
});

export default SOLR_SEARCH_REST_CONFIG_PROJECTS;
